import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53368)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M49.1373 41.3792H0.861619C0.385546 41.3792 -0.000488281 40.9932 -0.000488281 40.5171V9.48271C-0.000488281 9.00664 0.385546 8.62061 0.861619 8.62061H49.1374C49.6135 8.62061 49.9995 9.00664 49.9995 9.48271V40.5171C49.9994 40.9933 49.6134 41.3792 49.1373 41.3792Z",
				fill: "#F3F3F3"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M49.9994 22.4136H20.6891V8.62061H15.5168V22.4136H-0.000488281V27.5861H15.5168V41.3791H20.6891V27.5861H49.9994V22.4136Z",
				fill: "#41479B"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53368",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFlFlag);
export { ForwardRef as ReactComponent };
